import { useEffect, useState, useContext, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { getMaterialUrl } from '../../config/externalMaterials';
import './Hub.css';
import './Hub.responsive.css';
import { usePopupManager } from './helpers/usePopupManager';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../../authContext';
import { useMsal } from '@azure/msal-react';
import PublishModal from '../../components/PublishModal';
import ConfirmDeleteModal2 from '../../components/DeletAssitant/index';
import UpdatesModal from '../../components/UpdatesModal';
import FiveUpdatePopups from '../../components/UpdateDetailPopup/FiveUpdatePopups';
import PopUpChatOrClassifier from '../../components/PopUpChatOrClassifier/PopUpChatOrClassifier';
import { handleApiResponse } from '../../utils/handleApi';

// import TermsModal from '../../components/TermsModal';

function Hub({ setAssistant }) {
    const { user, level, email, assistantList, sessionId, setAssistantList, accessToken, newSessionId, popupStatus, setPopupStatus,
        updateId, termsAccepted, setTermsAccepted, isLogin, setIsLogin, neverSee, setNeverSee, fetchResourceGroup } = useContext(AuthContext);
    const navigate = useNavigate();
    const { instance } = useMsal(); // MSAL instance
    const { t: tHub } = useTranslation('hub');
    const { t: tCommon } = useTranslation('common');
    const { t: tSelfAssist } = useTranslation('assistantConfiguration');
    const { i18n } = useTranslation(); // Importa o i18n para obter o idioma atual
    const [openMenuId, setOpenMenuId] = useState(null);
    const dropdownRef = useRef(null);
    const [isPublishModal, setIsPublishModal] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [assistantIdToDelete, setAssistantIdToDelete] = useState(null);
    const [selectedAssistantForPublishing, setSelectedAssistantForPublishing] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');

    const [hasShownPopup, setHasShownPopup] = useState(false);
    const [isChatOrClassifierPopupOpen, setIsChatOrClassifierPopupOpen] = useState(false);

    const [updateSteps, setUpdateSteps] = useState([]);
    const [updateConfig, setUpdateConfig] = useState({ allow_skip: true, show_dots: true });
    // const [isTermsModalOpen, setIsTermsModalOpen] = useState(false); // Modal de termos

    const {
        activeUpdate,
        isFiveUpdatesOpen,
        isUpdatesModalOpen,
        stepsData,
        config,
        handleTestNow,
        handleSeeLater,
        handleCloseModal,
        modalStepsData,
        modalUpdateId,
        handleDontShowAgain,
        groupedUpdates,
        popupStatusByGroup,
        setModalUpdate,
        setPopupStatusByGroup,
        setIsUpdatesModalOpen,
    } = usePopupManager({ accessToken, isLogin, email, level, initialPopupStatus: popupStatus });

    // Handler centralizado para fechar o UpdatesModal e marcar como visto
    // Usamos sessionStorage para que a preferência dure apenas enquanto a sessão/tab estiver aberta.
    // Assim o modal aparece novamente em um novo login (nova sessão), mas não reaparece ao navegar
    // entre rotas durante a mesma sessão.
    const handleUpdatesModalClose = () => {
        setIsUpdatesModalOpen(false);
        try {
            sessionStorage.setItem('updates_modal_shown', 'true');
        } catch (e) {
            // se storage não estiver disponível, ignorar silenciosamente
        }
    };

    useEffect(() => {
        setAssistant('');
    }, [setAssistant]);

    // useEffect(() => {
    //     if (termsAccepted === false || termsAccepted === null) {
    //         setIsTermsModalOpen(true);
    //     } else if (termsAccepted === true) {
    //         setIsTermsModalOpen(false);
    //     }
    // }, [termsAccepted]);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(e.target) &&
                !e.target.closest('.gear-icon')
            ) {
                setOpenMenuId(null);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);


    // toggleMenu function removed as it wasn't used

    const fetchAssistantList = async () => {
        try {
            // 📌 Carrega assistentes com token autorizado
            const assistantResponse = await fetch(`${process.env.REACT_APP_API_URL}/post_assistants`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                },
                body: JSON.stringify({ email: email })
            });

            const data = await handleApiResponse(assistantResponse);
            const assistantData = await assistantResponse.json();
            if (!assistantResponse.ok) {
                throw new Error('Erro ao buscar assistentes.');
            }

            const validAssistants = [];
            const toDelete = [];

            for (const assistant of assistantData.assistants || []) {
                const { title, description } = getTextByAssistant(assistant);
                if (!title.trim() && !description.trim()) {
                    toDelete.push(assistant.id);
                } else {
                    validAssistants.push(assistant);
                }
            }

            // Mescla resultado do backend com a lista atual:
            // - preserva itens otimísticos pendentes (id começa com "optimistic-")
            // - preserva itens locais recém-injetados que ainda não chegaram no resultado do backend
            setAssistantList(prev => {
                const backendIds = new Set(validAssistants.map(a => String(a.id)));
                const localOnly = prev.filter(a => !backendIds.has(String(a.id)));
                return [...validAssistants, ...localOnly];
            });

            // Deleta os inválidos
            for (const id of toDelete) {
                try {
                    await fetch(`${process.env.REACT_APP_API_URL}/delete_assistant`, {
                        method: "DELETE",
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${accessToken}`
                        },
                        body: JSON.stringify({ assistant_id: id }),
                    });
                } catch (err) {
                    console.error(`Erro ao remover assistente inválido (${id}):`, err);
                }
            }
        } catch (error) {
            console.error("Erro ao carregar assistentes:", error);
        }
    };

    useEffect(() => {
        if (accessToken && email) {
            fetchAssistantList();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [accessToken, email]);

    const handleDeleteAssistant = async (event, assistantId) => {
        event.stopPropagation(); // Evita que o clique vá para o card

        // 🟡 Remove imediatamente do estado visível
        setAssistantList(prev => prev.filter(assistant => assistant.id !== assistantId));
        setOpenMenuId(null); // Fecha o menu
        setIsDeleteModalOpen(false);

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/delete_assistant`, {
                method: "DELETE",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                },
                body: JSON.stringify({ assistant_id: assistantId }),
            });

            if (!response.ok) {
                throw new Error(`Erro ao deletar assistente. Status: ${response.status}`);
            }

        } catch (error) {
            console.error("Erro ao tentar excluir assistente:", error);
            // 🔴 Restaura a lista original
            fetchAssistantList();
            alert("Não foi possível excluir o assistente.");
        }
    };



    // Função para lidar com o clique no assistente
    const handleAssistantClick = (selectedAssistant, assistantId, assistantIcon, type) => {
        setAssistant(selectedAssistant); // Atualiza o assistente selecionado

        if (type === "classifier") {
            setIsLogin(false);
            navigate('/category', { state: { assistantId: assistantId, assistantIcon } });

        } else if (type === "automation") {
            setIsLogin(false);
            navigate('/automation', { state: { assistantId: assistantId } });
        }
        else if (type === "sabesp_nts") {
            setIsLogin(false);
            navigate('/sabesp', { state: { assistantId, assistantIcon } });
        }
        else {
            setIsLogin(false)
            navigate('/siteAssist', { state: { assistantId, assistantIcon } }); // Redireciona para a página /siteAssist

        }
    };

    // Função para determinar a descrição correta conforme o idioma do navegador
    const getLocalizedDescription = (descriptions) => {
        if (!Array.isArray(descriptions) || descriptions.length === 0) {
            return ''; // Se a descrição não for um array válido, retorna string vazia
        }

        const userLanguage = i18n.language || navigator.language || 'en';
        const langKey = userLanguage.split('-')[0]; // en, pt, fr

        // Mapeia o código da linguagem para a chave usada nos objetos
        const langMap = {
            en: 'english',
            pt: 'portuguese',
            fr: 'french'
        };

        const langProp = langMap[langKey];

        // Se for uma lista de strings (formato antigo)
        if (typeof descriptions[0] === 'string') {
            return descriptions[0]; // Apenas retorna o primeiro
        }

        // Se for uma lista de objetos (formato novo)
        for (const descObj of descriptions) {
            if (descObj[langProp]) {
                return descObj[langProp];
            }
        }

        // Se não encontrar o idioma correspondente, tenta retornar inglês
        for (const descObj of descriptions) {
            if (descObj['english']) {
                return descObj['english'];
            }
        }

        // Se não encontrar nenhum idioma conhecido, retorna o primeiro valor possível
        const firstAvailable = Object.values(descriptions[0])[0];
        return firstAvailable || '';
    };

    // Função para retornar os dados de um assistente
    const getTextByAssistant = (assistant) => {
        return {
            title: assistant.nome || '',
            description: getLocalizedDescription(assistant.description),
            icon: assistant.icon || null // Ícone pode ser um SVG ou `null`
        };
    };

    const openNewAssistantModal = () => {
        setIsChatOrClassifierPopupOpen(true)
    };

    const handleCreateChat = () => {
        setIsChatOrClassifierPopupOpen(false);
        navigate('/assistantConfiguration', { state: { user, email } });
    };

    const handleCreateClassifier = () => {
        setIsChatOrClassifierPopupOpen(false);
        navigate('/category', { state: { openModelOnLoad: true, createMode: true } });
    };



    const handleGearClick = (event, assistantId) => {
        event.preventDefault();
        event.stopPropagation(); // Impede que o clique afete o card ou outros elementos

        setOpenMenuId(prevId => {
            // Só alterna se for diferente, senão mantém null (fecha)
            if (prevId === assistantId) return null;
            return assistantId;
        });
    };

    const EditAssistant = async (event, assistant) => {
        event.stopPropagation(); // Evita que o clique vá para o card
        navigate('/assistantConfiguration', { state: { user, sessionId, email, exists: true } });

        fetch(`${process.env.REACT_APP_API_URL}/post_assistant_storage`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${accessToken}`
            },
            body: JSON.stringify({ assistant_id: assistant.id }),
        }).catch(err => console.warn("Erro ao inicializar storage do assistente:", err));


        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/post_data_assistant`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${accessToken}`
                },
                body: JSON.stringify({
                    assistant_id: assistant.id,
                }),
            });
            const error = await handleApiResponse(response);
            const data = await response.json();


            // Atualiza o histórico para incluir os dados
            navigate('/assistantConfiguration', { replace: true, state: { assistantData: data, user, sessionId, email, exists: true } });

        } catch (error) {
            console.error("Erro ao obter dados do assistente:", error);
        }
    };

    const updateAssistantFields = async (assistantId, updatedFields) => {
        try {
            const payload = {
                _id: assistantId,
                ...updatedFields,
                updated_at: new Date().toISOString().split('T')[0]
            };

            const response = await fetch(`${process.env.REACT_APP_API_URL}/put_editing_assistant`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                },
                body: JSON.stringify({
                    data: payload
                }),
            });

            if (!response.ok) {
                throw new Error("Erro ao atualizar o assistente.");
            }

            // ✅ Após atualização, recarrega a lista de assistentes
            await fetchAssistantList();

        } catch (error) {
            console.error("Erro na atualização do assistente:", error);
        }
    };

    const handleStatus = async () => {
        if (!selectedAssistantForPublishing?._id) return;

        const newStatus = !selectedAssistantForPublishing.status;

        // Atualiza localmente
        setSelectedAssistantForPublishing(prev => ({
            ...prev,
            status: newStatus
        }));

        // Atualiza no backend
        await updateAssistantFields(selectedAssistantForPublishing._id, {
            status: newStatus
        });
    };

    const updateUserList = async (updatedUsers) => {
        if (!selectedAssistantForPublishing?._id) return;

        // Atualiza localmente
        setSelectedAssistantForPublishing(prev => ({
            ...prev,
            users: updatedUsers
        }));

        // Atualiza no backend
        await updateAssistantFields(selectedAssistantForPublishing._id, {
            users: updatedUsers
        });
    };

    const hubBackgroundStyle = {
        backgroundImage: "url('/imagens/background-hub.png')"
    };

    const btnUptades = {
        backgroundImage: "url('/imagens/background-btn-uptades.png')"
    }

    // Função para lidar com a mudança no input de busca
    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    // Filtra a lista de assistentes com base no termo de busca
    const filteredAssistants = assistantList.filter(assistant => {
        const { title } = getTextByAssistant(assistant);
        return title.toLowerCase().includes(searchTerm.toLowerCase());
    });

    // Função para enviar evento ao backend
    const sendPopupEvent = async (status) => {

        try {
            await fetch(`${process.env.REACT_APP_API_URL}/post_sendevents`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                },
                body: JSON.stringify({
                    email: email,
                    status: status,
                    id: updateId
                })
            });
            setPopupStatus(status);
        } catch (error) {
            console.error("Erro ao enviar evento do popup:", error);
        }
    };

    // Handler para "Testar agora"
    /*
    const handleTestNow = () => {
        sendPopupEvent('try_now');
        // Marca localmente que, nos próximos logins, deve abrir o modal de updates (grid)
        try {
            localStorage.setItem('updates_flow', 'modal');
        } catch (e) {
            // storage pode estar indisponível; ignorar silenciosamente
        }
        setIsFiveUpdatesOpen(false);
        setIsUpdatesModalOpen(true); // abre o modal de updates imediatamente
        setHasShownPopup(true); // garante que não reabra durante a sessão
    }; */


    // Handler para aceitar os termos
    const handleAcceptTerms = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/post_sendevents`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                },
                body: JSON.stringify({
                    email: email,
                    status: 'true',
                    id: 'term_use'
                })
            });

            if (!response.ok) {
                throw new Error('Erro ao registrar aceite dos termos.');
            }

            setTermsAccepted(true);
            // setIsTermsModalOpen(false);
        } catch (error) {
            console.error(error);
            alert('Não foi possível registrar o aceite dos termos. Tente novamente.');
        }
    };

    return (
        <div className='hub-box' data-testid='hub-box'>

            {/* <TermsModal
                isOpen={isTermsModalOpen}
                onAccept={handleAcceptTerms}
            /> */}


            <FiveUpdatePopups
                key={activeUpdate?._id}
                isOpen={isFiveUpdatesOpen}
                stepsData={stepsData}
                config={config}
                language={(i18n.language || 'pt').split('-')[0]}
                onTestNow={handleTestNow}
                onSeeLater={handleSeeLater}
            />



            <UpdatesModal
                isOpen={isUpdatesModalOpen}
                onClose={handleCloseModal}
                stepsData={modalStepsData}
                config={config}
                language={(i18n.language || 'pt').split('-')[0]}
                updateId={modalUpdateId}
                onDontShowAgain={handleDontShowAgain}
                groupedUpdates={groupedUpdates}
                popupStatusByGroup={popupStatusByGroup}
                setModalUpdate={setModalUpdate}
                setPopupStatusByGroup={setPopupStatusByGroup}
                setIsUpdatesModalOpen={setIsUpdatesModalOpen}
            />

            <PopUpChatOrClassifier
                isOpen={isChatOrClassifierPopupOpen}
                onClose={() => setIsChatOrClassifierPopupOpen(false)}
                onCreateChat={handleCreateChat}
                onCreateClassifier={handleCreateClassifier}
            />

            <PublishModal
                isOpen={isPublishModal}
                onClose={() => setIsPublishModal(false)}
                nome={selectedAssistantForPublishing?.nome}
                createdBy={selectedAssistantForPublishing?.createdBy}
                users={selectedAssistantForPublishing?.users}
                updateUserList={updateUserList}
                status={selectedAssistantForPublishing?.status}
                handleStatus={handleStatus}
                email={email}
            />

            <div className="hub-background-wrapper" style={hubBackgroundStyle}>
                <div className="main-home">

                    <div className='hub-content'>

                        <div className='text-container-homepage'>
                            <p className="text2">{tHub("title_hub")}</p>
                            <div className="search-container">
                                <input
                                    type="text"
                                    placeholder={tHub("search_assistant")}
                                    className="search-assistant-input"
                                    data-testid="search-assistant-input"
                                    value={searchTerm} // Adiciona o valor do estado
                                    onChange={handleSearchChange} // Adiciona o manipulador de mudança
                                />
                                <img src="/imagens/search-blue.svg" alt={tHub("searchIcon")} className="search-icon" />
                            </div>
                            <div className='buttons'>
                                {level !== 'externo' && (
                                    <button className='btn-updates' data-testid="about-iris" style={btnUptades} onClick={() => setIsUpdatesModalOpen(true)}>
                                        {tHub("uptades")}
                                    </button>
                                )}
                                {/*
                                <button className='btn-community' style={btnCommunity}>
                                    {tHub("community")}
                                </button>
                                */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="main-home">

                <div className='hub-content'>

                    {/* Contêiner do carrossel */}
                    <div className="carouselInner">

                        <div className="gridContainer" data-testid="gridContainer">

                            {/* Adiciona o card 'new-card' para qualquer usuario, exceto usuários externos */}

                            {level !== 'externo' && (
                                <div
                                    className="new-assistant"
                                    data-testid="new-assistant"
                                    onMouseEnter={(e) => (e.currentTarget.querySelector('img').src = '/imagens/add-assistant-full.svg')}
                                    onMouseLeave={(e) => (e.currentTarget.querySelector('img').src = '/imagens/add-assistant.svg')}
                                    onClick={openNewAssistantModal}
                                >
                                    <div className="icon-container">
                                        <div className="moduleEllipse add">
                                            <span className="material-symbols-outlined icon-style">
                                                <img src="/imagens/add-assistant.svg" alt={tHub("addAssistant")} />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* *
                            {(level !== 'adm' && level != 'dev' && level != 'mod') && (
                                <div
                                    className="new-assistant"
                                    data-testid="new-assistant"
                                    onMouseEnter={(e) => (e.currentTarget.querySelector('img').src = '/imagens/add-assistant-full.svg')}
                                    onMouseLeave={(e) => (e.currentTarget.querySelector('img').src = '/imagens/add-assistant.svg')}
                                    onClick={() => window.open(getMaterialUrl('requestAssistantForm', i18n.language), '_blank')}
                                >
                                    <div className="icon-container">
                                        <div className="moduleEllipse add">
                                            <span className="material-symbols-outlined icon-style">
                                                <img src="/imagens/add-assistant.svg" alt={tHub("addAssistant")} />
                                            </span>
                                        </div>
                                    </div>
                                    <div className={`description-homepage`} style={{ marginTop: '20px', color: '#818285', fontWeight: '500', fontSize: '16px' }}>{tHub("requestAssistant")} </div>
                                </div>
                            )} /}

                            {/* Renderiza os assistentes apenas se houver pelo menos um na lista */}
                            {filteredAssistants.length > 0 &&
                                filteredAssistants
                                    .slice() // cria uma cópia para não mutar o original
                                    .sort((a, b) => Number(a.id) - Number(b.id)) // ordena por ID numérico crescente
                                    .map((assistant, index) => {
                                        const { title, description, icon } = getTextByAssistant(assistant);
                                        const isDisabled = !assistant.status; // Verifica se o card deve estar desativado
                                        if (!title.trim() && !description.trim()) {
                                            return null; // não renderiza
                                        }
                                        return (
                                            <div
                                                key={index}
                                                className={`homepage-card 
                                                    ${isDisabled ? 'disabled-card' : ''} 
                                                    ${assistant.id === "0" ? 'blue-card' : ''}
                                                    ${openMenuId === assistant.id ? 'active' : ''}`}
                                                data-testid="homepage-card"
                                                onClick={(e) => {
                                                    if (!isDisabled) {
                                                        handleAssistantClick(assistant.nome, assistant.id, assistant.icon, assistant.type);
                                                    } else {
                                                        e.stopPropagation(); // Impede que o clique desative o menu
                                                    }
                                                }}
                                            >
                                                {/* Engrenagem */}
                                                {assistant.adms?.some(adm => adm.email === email) && (
                                                    <div className="gear-wrapper" >
                                                        <img
                                                            src="/imagens/gear.svg"
                                                            alt={tCommon("settings")}
                                                            className="gear-icon"
                                                            data-testid="gear-icon"
                                                            onClick={(e) => handleGearClick(e, assistant.id)}
                                                        />
                                                        {openMenuId === assistant.id && (
                                                            <div className={`menu-dropdown ${(assistant.type !== "self_assistant" && assistant.type !== "classifier") ? 'no-self-assistant-dropdown' : ''}`} ref={dropdownRef}>
                                                                {assistant.type === "self_assistant" && (<div
                                                                    className="menu-item"
                                                                    data-testid="menu-item"
                                                                    onClick={(event) => EditAssistant(event, assistant)}
                                                                >
                                                                    {tCommon("edit")}
                                                                </div>)}

                                                                <div
                                                                    className="menu-item"
                                                                    data-testid="menu-item"
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        setSelectedAssistantForPublishing({
                                                                            nome: assistant.nome,
                                                                            // O verdadeiro criador deve ser o owner
                                                                            createdBy: assistant.created_by || assistant.adms?.[0]?.email || '',
                                                                            users: assistant.users || [],
                                                                            status: assistant.status,
                                                                            _id: assistant.id
                                                                        });
                                                                        setIsPublishModal(true);
                                                                    }}
                                                                >
                                                                    {tSelfAssist("managing_publication")}
                                                                </div>

                                                                {(assistant.type === "self_assistant" || assistant.type === "classifier") && (<div
                                                                    className="menu-item delete"
                                                                    data-testid="menu-delete"
                                                                    onClick={(event) => {
                                                                        event.stopPropagation();
                                                                        setAssistantIdToDelete(assistant.id);
                                                                        setIsDeleteModalOpen(true);
                                                                    }}
                                                                >
                                                                    {tCommon("delete")}
                                                                </div>)}
                                                            </div>
                                                        )}
                                                    </div>
                                                )}

                                                {/* Ícone */}
                                                <div className='icon-container'>
                                                    <div className='moduleEllipse'>
                                                        {icon ? (
                                                            <div
                                                                className="icon-style"
                                                                dangerouslySetInnerHTML={{ __html: icon }}
                                                            />
                                                        ) : (
                                                            <img src="/imagens/biblioteca/androidLogo.svg" alt={tHub("assistantIcon", { name: title })} />
                                                        )}
                                                    </div>
                                                </div>
                                                {/* Texto */}
                                                <div className={`text-style-card-homepage ${assistant.id === "0" ? 'white-text' : ''}`}>{title}</div>
                                                <div className={`description-homepage ${assistant.id === "0" ? 'white-text' : ''}`}>{description}</div>
                                            </div>
                                        );
                                    })}


                        </div>
                    </div>

                </div>

            </div>

            <ConfirmDeleteModal2
                isOpen={isDeleteModalOpen}
                onClose={() => {
                    setIsDeleteModalOpen(false);
                    setAssistantIdToDelete(null);
                }}
                onConfirm={(event) => {
                    if (assistantIdToDelete) {
                        handleDeleteAssistant(event, assistantIdToDelete);
                    }
                }}
            />

            <div className='suggestion-wrapper' onClick={() => window.open(getMaterialUrl('suggestionForm', i18n.language), '_blank')}>
                <img src="/imagens/lamp-hub.svg" alt={tHub("lampIcon")} className='lamp-icon' />
            </div>


            <footer className='footer-hub'></footer>
        </div>
    );
}

export default Hub;